//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

// 物料配方主数据详情
const prescriptionDataList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/prescriptionData/list.vue');

//新增物料配方主数据
const prescriptionDataAdd = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/prescriptionData/add.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'prescriptionDataList',
      name: 'prescriptionDataList',
      component: prescriptionDataList,
      meta: {
        keepAlive: true,
        title: '物料配方主数据',
      },
    },
    {
      path: 'prescriptionDataAdd',
      name: 'prescriptionDataAdd',
      component: prescriptionDataAdd,
      meta: {
        keepAlive: true,
        title: '物料配方主数据新增',
      },
    },
  ],
};
export default productionRouter;
